import { Suspense } from "react";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import Spinner from '@/common/react/Spinner';
import SliderSection from "./components/SliderSection";

function ShopTheLook() {
  return window.shopTheLookSettings && (
  <Suspense fallback={<Spinner hidden />}>
    <LazyLoadComponent>
      <SliderSection settings={window.shopTheLookSettings} />
    </LazyLoadComponent>
  </Suspense>
  );
}

export default ShopTheLook;
